import React, { useState, useEffect } from "react";
import {
	IonItem,
	IonLabel,
	IonInput,
	IonText,
	IonDatetime,
	IonButton,
	IonIcon,
	IonProgressBar,
	IonAvatar,
	IonCol,
	IonModal,
	isPlatform,
} from "@ionic/react";
import "../../global.scss";
import { locationSharp, chevronBackOutline, star, chevronForward } from "ionicons/icons";
import {
	PERSONAL_DETAILS,
	NAME,
	EMAIL_ADDRESS,
	DOB,
	GENDER,
	CONTINUE,
	PROFILE_COMPLETION,
	MY_PROFILE,
	PROFILE_DETAILS,
	PROFILE_VEHICLES,
	DOCUMENT_VAULT,
	MY_ADDRESS,
	MOBILE_NUMBER,
	EDIT,
	PLEASE_ENTER_NAME,
	PLEASE_ENTER_VALID_MOBILE_NUMBER,
	PLEASE_SELECT_THE_GENDER,
	SAVED_SUCCESSFULLY,
	PLEASE_ENTER_VALID_EMAIL,
	COUNTRY_CODE,
	PLEASE_ENTER_VALID_NAME,
	SAVE,
	CANCEL,
	OK,
	YEAR,
	MONTH,
	DATE,
	PLEASE_SELECT_DOB,
	AGE_SHOULD_BE_GREATER_THAN_18,
	NAME_SHOULD_BE_MIN_3_CHAR,
} from "../../constants";
import { connect } from "react-redux";
import {
	validateEmail,
	validateMobileNumber,
	alphabitsLetters,
	validDate,
	checkMediaQuery,
} from "../../utils";
import { COLLECTIONS, getDoc, updateDoc } from "../../firebase";
import { updateOnBoarding } from "../../Store/Actions";
import { ToastMessage } from "../../utils/toastMessage";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "../OnBoarding/PersonalDetails.scss";

const PersonalDetails: React.FC = (props: any) => {
	const [selectedGender, setGender] = useState("Male");
	const [screenName, setScreenName] = useState("PersonalDetails");
	const [profileDetails, setprofileDetails] = useState(false);
	const [selectedFuel, setFuel] = useState("Diesel");
	const [enableSave, setEnableSave] = useState(false);
	const [disabled, setDisabled] = useState(false);
	const [showPicker, setPicker] = useState(false);
	const [date, setDate] = useState("");
	const days = ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"];
	const months = [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"June",
		"July",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec",
	];
	const [toast, setToast] = useState({
		showToast: false,
		toastMessage: "",
		severity: "",
	});

	const [state, setState] = useState({
		name: props.name || "",
		email: props.email || "",
		date_of_birth: props.date_of_birth || "",
		date_of_birth_temp: props.date_of_birth || "",
		gender: props.gender || "",
		primaryPhoneNumber: props.primaryPhoneNumber || "",
	});

	useEffect(() => {
		fetchDataAsync();
		return () => {
			setState({
				name: "",
				email: "",
				date_of_birth: "",
				date_of_birth_temp: "",
				gender: "",
				primaryPhoneNumber: "",
			});
		};
	}, [props.uid]);

	const fetchDataAsync = async () => {
		if (props.uid) {
			const response: any = await getDoc(props.uid, COLLECTIONS.USERS);
			if (response.exists) {
				setState({
					...response.data,
					date_of_birth:
						response.data.date_of_birth && response.data.date_of_birth.seconds
							? new Date(response.data.date_of_birth.seconds * 1000)
							: response.data.date_of_birth
							? new Date(response.data.date_of_birth)
							: "",
					date_of_birth_temp:
						response.data.date_of_birth && response.data.date_of_birth.seconds
							? new Date(response.data.date_of_birth.seconds * 1000)
							: response.data.date_of_birth
							? new Date(response.data.date_of_birth)
							: "",
				});
			}
		}
	};

	const handleChange = (key: any, value: any) => {
		setState({
			...state,
			[key]: value,
		});
		setEnableSave(true);
	};

	const savePersonalDetails = async () => {
		try {
			const { name, email, date_of_birth, gender, primaryPhoneNumber }: any = state;
			const { uid, token, profileImagePath } = props;
			const thisYear = new Date().getFullYear();
			if (!name.trim().length || !alphabitsLetters(name)) {
				throw new Error(!name.length ? PLEASE_ENTER_NAME : PLEASE_ENTER_VALID_NAME);
			}
			if (name.trim().length < 3) {
				throw new Error(NAME_SHOULD_BE_MIN_3_CHAR);
			}
			if (!!email ? !validateEmail(email) : false) {
				throw new Error(PLEASE_ENTER_VALID_EMAIL);
			}
			if (
				!primaryPhoneNumber ||
				!validateMobileNumber(primaryPhoneNumber) ||
				(!props.primaryPhoneNumber && primaryPhoneNumber.length !== 9)
			) {
				throw new Error(PLEASE_ENTER_VALID_MOBILE_NUMBER);
			}
			if (!gender) {
				throw new Error(PLEASE_SELECT_THE_GENDER);
			}
			// if (!date_of_birth) {
			//   throw new Error(PLEASE_SELECT_DOB);
			// }
			if (
				!!date_of_birth ? thisYear - new Date(date_of_birth).getFullYear() < 18 : false
			) {
				throw Error(AGE_SHOULD_BE_GREATER_THAN_18);
			}
			if (token) {
				const payload = {
					name: state.name.charAt(0).toUpperCase() + state.name.slice(1),
					email: state.email || "",
					primaryPhoneNumber: !props.primaryPhoneNumber
						? "+971" + state.primaryPhoneNumber
						: state.primaryPhoneNumber,
					profileImagePath: profileImagePath,
					onBoarding: !!props.onBoarding ? props.onBoarding : false,
					gender: state.gender || "",
					date_of_birth: new Date(state.date_of_birth).getTime() || "",
					profileCompleteness: 40,
				};
				await updateDoc(uid, payload, COLLECTIONS.USERS);
				await props.updateOnBoarding(payload);
				await setState({
					...state,
					primaryPhoneNumber: !props.primaryPhoneNumber
						? "+971" + state.primaryPhoneNumber
						: state.primaryPhoneNumber,
				});
				setToast({
					toastMessage: SAVED_SUCCESSFULLY,
					showToast: true,
					severity: "success",
				});
				setEnableSave(false);
				setTimeout(() => {
					!!!props.onBoarding
						? props.history.push("/onboarding/add-vehicle")
						: props.history.push("/portal");
				}, 1000);
			}
		} catch (error: any) {
			setToast({
				toastMessage: error.message,
				showToast: true,
				severity: "warning",
			});
		}
	};

	window.addEventListener("resize", checkMediaQuery);

	return (
		<>
			<IonCol className="middle_panle" size-md="6">
				{screenName === "PersonalDetails" && profileDetails === false && (
					<>
						<div className="personal_details_div wholeApp">
							<div
								className="personal_details_div_child pd_header_floating"
								style={{
									paddingTop: isPlatform("android") ? 20 : 0,
								}}
							>
								{props.onBoarding === true && (
									<img
										src={
											checkMediaQuery()
												? "/images/gray_backarrow.svg"
												: "/images/back_arrow.svg"
										}
										className="back_arrow"
										onClick={() => props.history.goBack()}
									/>
								)}

								<IonLabel className="personal_details_labels" color="secondary">
									{PERSONAL_DETAILS}
								</IonLabel>
								<div />
							</div>
						</div>
						<div className="personal_details_text height_100Per left_right_padding personal_detail_header">
							<div className="marginT_80 marginTop50">
								<IonLabel className="name_text">{NAME}</IonLabel>
								<div className="name_input_div">
									<IonInput
										maxlength={100}
										placeholder="Enter your full name here"
										type="text"
										className="name_input_icon capitalize"
										color="tertiary"
										value={state.name}
										onIonChange={(event: any) => {
											handleChange("name", event.detail.value);
										}}
									/>
								</div>
							</div>
							<div className="personal_details_div">
								<IonLabel className="name_text email_text email_text_res">
									{EMAIL_ADDRESS}
								</IonLabel>
								<div className="name_input_div pd_left_res" style={{ height: 45 }}>
									{/* <input
                    placeholder="Eg: yourname@mail.com"
                    type="text"
                    className={!!props.email ? "login22 no_drop" : "login22"}
                    color="tertiary"
                    value={state.email}
                    onChange={(event: any) =>
                      handleChange("email", event.target.value)
                    }
                    readOnly={!!props.email}
                  /> */}
									<IonInput
										placeholder="Eg: yourname@mail.com"
										type="text"
										className={
											!!props.email
												? "login22 no_drop inputFieldMarginLeft10"
												: "login22 inputFieldMarginLeft10"
										}
										color="tertiary"
										value={state.email}
										onIonChange={(event: any) => {
											handleChange("email", event.detail.value);
										}}
										readonly={!!props.email}
									/>
								</div>
							</div>

							<div className="personal_details_div">
								<IonLabel
									className="name_text email_text email_text_res"
									color="secondary"
								>
									{MOBILE_NUMBER}
								</IonLabel>
								<div className="name_input_div pd_left_res" style={{ height: 45 }}>
									<IonLabel
										className="Mobile-number-label padding_left_10"
										color="tertiary"
										position="fixed"
									>
										{COUNTRY_CODE}
									</IonLabel>
									<input
										type="tel"
										maxLength={9}
										onChange={(event) =>
											(/^\d+$/.test(event.target.value) || !event.target.value) &&
											handleChange("primaryPhoneNumber", event.target.value)
										}
										value={
											!!props.primaryPhoneNumber && props.primaryPhoneNumber.length > 10
												? state.primaryPhoneNumber.slice(4)
												: state.primaryPhoneNumber
										}
										className={
											!!props.primaryPhoneNumber ? " login22 no_drop" : "login22"
										}
										readOnly={!!props.primaryPhoneNumber}
									/>
								</div>
							</div>
							<div className="name_text email_text email_text_res">
								<IonLabel color="secondary" className="label_text">
									{DOB}
								</IonLabel>
								<div className="calender personal_details_calender">
									<IonInput
										className="calender-input calender-item"
										color="tertiary"
										placeholder={DATE}
										readonly={true}
										value={new Date(state.date_of_birth).getDate() || ""}
									/>
									<IonInput
										className="calender-input calender-item"
										color="tertiary"
										placeholder={MONTH}
										readonly={true}
										value={months[new Date(state.date_of_birth).getMonth()] || ""}
									/>
									<IonInput
										className="calender-input calender-item"
										color="tertiary"
										placeholder={YEAR}
										readonly={true}
										value={new Date(state.date_of_birth).getFullYear() || ""}
									/>
									<img
										className="calender-img"
										src="/images/calendar1.svg"
										alt="calendar"
										onClick={() => setPicker(true)}
									/>
								</div>
							</div>

							<div className="name_text email_text email_text_res">
								<IonLabel className="label_text">{GENDER}</IonLabel>
							</div>
							<IonItem lines="none" className="gender-div">
								<div className="gender_label">
									{["Male", "Female", "Other"].map((ele) => (
										<div
											key={ele}
											className={
												state.gender === ele
													? "gender_label_selected"
													: "gender_label_child"
											}
											onClick={() => handleChange("gender", ele)}
										>
											<IonLabel
												className="gender_label_text"
												style={{
													color: state.gender === ele ? "white" : "#999999",
												}}
											>
												{ele}
											</IonLabel>
										</div>
									))}
								</div>
							</IonItem>
						</div>
						<div
							className="btn_parent_div mrgn_top_100 pd_save_footer"
							style={{
								marginRight: 25,
								marginLeft: 25,
								width: "-webkit-fill-available",
							}}
						>
							<IonButton
								type="button"
								onClick={() => savePersonalDetails()}
								color="primary"
								disabled={disabled}
								className="continue_btn child_btn res_btn_align"
								style={{
									marginBottom: 30,
									minWidth: "auto",
									width: "100%",
									maxWidth: checkMediaQuery() ? "none" : 320,
								}}
								// expand="block"
							>
								{/* {!props.onBoarding ? CONTINUE : enableSave ? "Save" : EDIT} */}
								{CONTINUE}
							</IonButton>
						</div>
					</>
				)}
				<ToastMessage
					showToast={toast.showToast}
					ToastMessage={toast.toastMessage}
					severity={toast.severity}
					onDidDismiss={() => {
						setToast({
							showToast: false,
							toastMessage: "",
							severity: "",
						});
					}}
				/>
				<IonModal
					isOpen={showPicker}
					backdropDismiss={true}
					onDidDismiss={() => {
						setPicker(false);
					}}
					cssClass="picker-modal"
				>
					<div className="picker-header">
						<IonLabel className="picker-header-year">
							{!!state.date_of_birth && validDate(state.date_of_birth)
								? new Date(state.date_of_birth).getFullYear()
								: new Date().getFullYear()}
						</IonLabel>
						<div className="picker-header-month-date-div">
							<IonLabel className="picker-header-month-date">
								{!!state.date_of_birth && validDate(state.date_of_birth)
									? days[new Date(state.date_of_birth).getDay()]
									: days[new Date().getDay()]}
								{","}{" "}
							</IonLabel>
							<IonLabel className="picker-header-month-date">
								{!!state.date_of_birth && validDate(state.date_of_birth)
									? new Date(state.date_of_birth).getDate() + " "
									: new Date().getDate() + " "}
							</IonLabel>
							<IonLabel className="picker-header-month-date">
								{!!state.date_of_birth && validDate(state.date_of_birth)
									? months[new Date(state.date_of_birth).getMonth()]
									: months[new Date().getMonth()]}
							</IonLabel>
						</div>
					</div>
					<Calendar
						onChange={(date: any) => {
							handleChange("date_of_birth", date);
						}}
						value={new Date(state.date_of_birth)}
						defaultActiveStartDate={
							!!state.date_of_birth && validDate(state.date_of_birth)
								? new Date(state.date_of_birth)
								: new Date()
						}
						maxDate={new Date()}
						defaultView={"month"}
					/>
					<div className="picker-actions-div">
						<IonButton
							onClick={() => {
								handleChange("date_of_birth", state.date_of_birth_temp);
								setPicker(false);
							}}
							color="light"
							className="picker-action-buttons"
						>
							{CANCEL}
						</IonButton>
						<IonButton
							color="light"
							className="picker-action-buttons"
							onClick={() => {
								handleChange("expirationDate", date);
								setPicker(false);
							}}
						>
							{OK}
						</IonButton>
					</div>
				</IonModal>
			</IonCol>
		</>
	);
};

export default connect(
	({ auth }: any) => {
		return {
			...auth,
		};
	},
	{ updateOnBoarding }
)(PersonalDetails);
